(function () {
  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function ensureQuantityInput(form, value) {
    var q = form.querySelector('input[name="quantity"]');
    if (!q) {
      q = document.createElement('input');
      q.type = 'hidden';
      q.name = 'quantity';
      form.appendChild(q);
    }
    q.value = String(value);
  }

    function ensureVariantInput(form, variantId) {
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) {
        idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        form.appendChild(idInput);
      }
      idInput.value = String(variantId);
    }

    function init(root) {
    var durationSec = parseInt(root.getAttribute('data-reserved-duration-seconds') || '600', 10);
    if (Number.isNaN(durationSec) || durationSec < 1) durationSec = 600;
    var endMs = Date.now() + durationSec * 1000;

    var mmEl = root.querySelector('[data-reserved-minutes]');
    var ssEl = root.querySelector('[data-reserved-seconds]');

    function tickReserved() {
      var diff = Math.max(0, endMs - Date.now());
      var m = Math.floor(diff / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (mmEl) mmEl.textContent = pad2(m);
      if (ssEl) ssEl.textContent = pad2(s);
    }
    tickReserved();
    setInterval(tickReserved, 1000);

    var cards = root.querySelectorAll('[data-bundle-tier]');
    var cta = root.querySelector('[data-bundle-cta]');
    var ctaPrice = root.querySelector('[data-cta-current-price]');
    var ctaCompare = root.querySelector('[data-cta-compare-price]');
    var compareWrap = root.querySelector('[data-cta-compare-wrap]');
    var ctaLabel = root.querySelector('[data-cta-label]');
    var ctaSpinner = root.querySelector('[data-cta-spinner]');
    var ctaMid = root.querySelector('[data-cta-mid]');
    var ctaArrow = root.querySelector('[data-cta-arrow]');
    var defaultCtaLabel = ctaLabel ? ctaLabel.textContent : '';

    function setCheckoutLoading(loading) {
      var loadingLabel = root.getAttribute('data-cta-loading-label') || 'Redirecting to checkout...';

      if (cta) {
        cta.classList.toggle('is-loading', loading);
        cta.disabled = loading;
        cta.setAttribute('aria-busy', loading ? 'true' : 'false');
      }
      if (ctaLabel) {
        ctaLabel.textContent = loading ? loadingLabel : defaultCtaLabel;
      }
      if (ctaSpinner) ctaSpinner.hidden = !loading;
      if (ctaMid) ctaMid.hidden = loading;
      if (ctaArrow) ctaArrow.hidden = loading;

      try {
        window.dispatchEvent(
          new CustomEvent('landing-bundle:checkout-state', {
            detail: { loading: loading, loadingLabel: loadingLabel, root: root },
          })
        );
      } catch (e) {}
    }

    function applySelection(card) {
      var pairs = parseInt(card.getAttribute('data-pairs') || '1', 10);
      var price = card.getAttribute('data-cta-price') || '';
      var compare = card.getAttribute('data-cta-compare') || '';
      var variantId = card.getAttribute('data-variant-id');

      cards.forEach(function (c) {
        c.classList.toggle('is-selected', c === card);
        c.setAttribute('aria-checked', c === card ? 'true' : 'false');
      });

      if (ctaPrice) ctaPrice.textContent = price;
      if (compareWrap) {
        if (compare) {
          compareWrap.hidden = false;
          if (ctaCompare) ctaCompare.textContent = compare;
        } else {
          compareWrap.hidden = true;
          if (ctaCompare) ctaCompare.textContent = '';
        }
      }

      var form =
        document.querySelector('product-form form[data-type="add-to-cart-form"]') ||
        document.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        if (variantId) {
          ensureVariantInput(form, variantId);
          ensureQuantityInput(form, 1);
        } else {
          ensureQuantityInput(form, pairs);
        }
      }

      try {
        window.dispatchEvent(
          new CustomEvent('landing-bundle:change', {
            detail: { pairs: pairs, variantId: variantId, root: root },
          })
        );
      } catch (e) {}
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        applySelection(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          applySelection(card);
        }
      });
    });

    var selected = root.querySelector('[data-bundle-tier].is-selected') || root.querySelector('[data-bundle-tier]');
    if (selected) applySelection(selected);

    function goToCheckout(variantId, quantity) {
      setCheckoutLoading(true);

      var locale = (root.getAttribute('data-checkout-locale') || '').replace(/^\/+|\/+$/g, '');
      var prefix = locale ? '/' + locale : '';

      var items = [{ id: parseInt(variantId, 10), quantity: quantity || 1 }];

      fetch(prefix + '/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      })
        .then(function () {
          return fetch(prefix + '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items }),
          });
        })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data.status) {
            setCheckoutLoading(false);
            return;
          }
          window.location.href = prefix + '/checkout';
        })
        .catch(function () {
          setCheckoutLoading(false);
        });
    }

    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        var selectedCard = root.querySelector('[data-bundle-tier].is-selected');
        var pairs = selectedCard ? parseInt(selectedCard.getAttribute('data-pairs') || '1', 10) : 1;
        var variantId = selectedCard ? selectedCard.getAttribute('data-variant-id') : null;
        var ctaAction = root.getAttribute('data-cta-action') || 'product';

        if (ctaAction === 'checkout' && variantId) {
          goToCheckout(variantId, 1);
          return;
        }

        var baseUrl = root.getAttribute('data-product-url') || root.getAttribute('data-chooser-url') || '/pages/ca01';
        if (variantId) {
          var productUrl = baseUrl.split('?')[0];
          window.location.href = productUrl + '?variant=' + variantId;
        } else {
          window.location.href = baseUrl + '?quantity=' + pairs;
        }
      });
    }
  }

  document.querySelectorAll('[data-landing-bundle-root]').forEach(init);
})();
